import { Link } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import { images } from "@/config/images";
import { site } from "@/config/site";

export default function Contact() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main className="pt-24 md:pt-28 pb-16">
        {/* ページタイトル */}
        <div className="bg-background-100 border-b border-background-200">
          <div className="max-w-6xl mx-auto px-4 md:px-6 py-10 md:py-14 text-center">
            <p className="inline-flex items-center gap-2 text-xs md:text-sm font-bold text-primary-700 bg-primary-100 rounded-full px-4 py-1.5 mb-4">
              <i className="ri-chat-3-line"></i>
              お問い合わせ
            </p>
            <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              お問い合わせ
            </h1>
            <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
              商品についてのお問い合わせやご質問は、公式LINEからお気軽にご連絡ください。
            </p>
          </div>
        </div>

        <div className="max-w-xl mx-auto px-4 md:px-6 mt-12 text-center">
          {/* LINE QRコード */}
          <div id="line-qr" className="flex flex-col items-center">
            <div className="w-full max-w-[200px] md:max-w-xs bg-white rounded-lg overflow-hidden border border-background-200 p-4">
              <img
                src={images.lineQr}
                alt="株式会社MEGURI 公式LINE QRコード"
                className="w-full h-full object-contain"
              />
            </div>
            <p className="mt-4 text-sm md:text-base text-foreground-700">
              QRコードを読み取って公式LINEをお友だち追加してください
            </p>
          </div>

          {/* LINEボタン */}
          <a
            href={site.lineUrl || "#line-qr"}
            target={site.lineUrl ? "_blank" : undefined}
            rel={site.lineUrl ? "noopener noreferrer" : undefined}
            className="inline-flex items-center justify-center gap-2 mt-8 bg-primary-500 hover:bg-primary-600 text-background-50 text-base font-bold px-8 py-3.5 rounded-md whitespace-nowrap transition-colors"
          >
            <i className="ri-line-line"></i>
            公式LINEからお問い合わせ
          </a>

          {/* 購入導線 */}
          <div className="mt-10 pt-6 border-t border-background-200">
            <p className="text-sm text-foreground-600">
              商品のご購入は、購入ページからお手続きください。
            </p>
            <Link
              to="/purchase"
              className="inline-flex items-center justify-center gap-2 mt-4 bg-background-100 hover:bg-background-200 text-foreground-900 text-sm font-bold px-6 py-3 rounded-md whitespace-nowrap transition-colors border border-background-300"
            >
              <i className="ri-shopping-bag-line"></i>
              購入ページへ
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}